import { appendCrossHostLocaleParam } from "../appendCrossHostLocaleParam";
import { readStoredMarketCountry } from "@mivo/i18n";

const defaultMarketingUrl = "http://localhost:3000";

export function resolveMarketingUrl(path: string, locale?: string | null, marketCountry?: string | null): string {
  const base = (import.meta.env.VITE_MARKETING_URL?.trim() || defaultMarketingUrl).replace(/\/$/, "");
  const normalizedPath = path.startsWith("/") || path.startsWith("#") ? path : `/${path}`;
  const resolved = `${base}${normalizedPath}`;
  return appendCrossHostLocaleParam(resolved, locale, marketCountry ?? readStoredMarketCountry());
}
